import { useEffect, useRef } from 'react';
import './contacts.css';

export default function Contacts() {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const scriptLoadedRef = useRef(false); // Флаг загрузки скрипта

  useEffect(() => {
    const initMap = () => {
      if (!window.ymaps || !mapRef.current || mapInstanceRef.current) return;

      mapRef.current.innerHTML = '';

      const map = new window.ymaps.Map(mapRef.current, {
        center: [59.75316267354724, 30.595886287598628],
        zoom: 17,
        controls: ['zoomControl']
      });

      const placemark = new window.ymaps.Placemark(
        [59.75316267354724, 30.595886287598628],
        {
          balloonContent: 'Санкт-Петербург, г. Колпино, территория Ижорского завода, 21ЖЯ'
        }
      );

      map.geoObjects.add(placemark);
      mapInstanceRef.current = map;
    };

    // Если API уже загружено
    if (window.ymaps) {
      window.ymaps.ready(initMap);
      return;
    }

    // Если скрипт уже добавлен, не добавляем повторно
    if (scriptLoadedRef.current) {
      return;
    }
    scriptLoadedRef.current = true;

    const script = document.createElement('script');
    script.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU'; // Исправлено: https://
    script.async = true;

    script.onload = () => {
      window.ymaps.ready(initMap);
    };

    script.onerror = () => {
      console.error('Ошибка загрузки API Яндекс Карт');
      scriptLoadedRef.current = false; // Разрешаем повторную попытку при следующем рендере
    };

    document.head.appendChild(script);

    return () => {
      // Очистка при размонтировании компонента
      if (mapInstanceRef.current) {
        mapInstanceRef.current.destroy();
        mapInstanceRef.current = null;
      }
      // Не удаляем скрипт из head — это может повлиять на другие компоненты
    };
  }, []);

  return (
    <section id="kontakty" className="contacts-footer">
      <div className="contacts-content">
        <div className="contacts-row">
          <div className="contacts-info">
            <h3 className="contacts-title">Наши контакты</h3>

            <div className="contacts-center">
              <p className="contacts-mail">📧 xarmet@inbox.ru</p>
              <p className="contacts-phone">📞 +7 (952) 350-43-16</p>
              <p className="contacts-address">
                📍 Санкт-Петербург, г. Колпино, территория Ижорского завода, 21ЖЯ
              </p>
              <p className="company-info">
                <br/>ООО "Характер металла"
                ИНН 7817122584
                ОГРН 1227800107314</p>
            </div>
          </div>

          <div className="contacts-map">
            <div ref={mapRef} style={{ width: '100%', height: '220px' }} />
          </div>
        </div>
      </div>
    </section>
  );
}
